"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ProductIcon = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Spaces = _interopRequireDefault(require("./svg/Spaces"));

var _Apis = _interopRequireDefault(require("./svg/Apis"));

var _Billing = _interopRequireDefault(require("./svg/Billing"));

var _Home = _interopRequireDefault(require("./svg/Home"));

var _Media = _interopRequireDefault(require("./svg/Media"));

var _ContentModel = _interopRequireDefault(require("./svg/ContentModel"));

var _Content = _interopRequireDefault(require("./svg/Content"));

var _Apps = _interopRequireDefault(require("./svg/Apps"));

var _Oauth = _interopRequireDefault(require("./svg/Oauth"));

var _OrgInfo = _interopRequireDefault(require("./svg/OrgInfo"));

var _Organizations = _interopRequireDefault(require("./svg/Organizations"));

var _Purchase = _interopRequireDefault(require("./svg/Purchase"));

var _Settings = _interopRequireDefault(require("./svg/Settings"));

var _Sso = _interopRequireDefault(require("./svg/Sso"));

var _Subscription = _interopRequireDefault(require("./svg/Subscription"));

var _Teams = _interopRequireDefault(require("./svg/Teams"));

var _Token = _interopRequireDefault(require("./svg/Token"));

var _Usage = _interopRequireDefault(require("./svg/Usage"));

var _UserProfile = _interopRequireDefault(require("./svg/UserProfile"));

var _Users = _interopRequireDefault(require("./svg/Users"));

var _excluded = ["className", "icon", "size", "color", "testId", "tag"];
var styles = {
  "ProductIconContainer": "ProductIcon__ProductIconContainer___KxjpT",
  "ProductIconContainer--small": "ProductIcon__ProductIconContainer--small___3EUYb",
  "ProductIconContainer--medium": "ProductIcon__ProductIconContainer--medium___2i2vS",
  "ProductIconContainer--large": "ProductIcon__ProductIconContainer--large___2-NC8",
  "ProductIconContainer--xlarge": "ProductIcon__ProductIconContainer--xlarge___38OWv",
  "ProductIconContainer--trimmed": "ProductIcon__ProductIconContainer--trimmed___2u-_5",
  "ProductIcon": "ProductIcon__ProductIcon___3MTbf",
  "ProductIcon--primary": "ProductIcon__ProductIcon--primary___2YVo_",
  "ProductIcon--positive": "ProductIcon__ProductIcon--positive___3gPLA",
  "ProductIcon--white": "ProductIcon__ProductIcon--white___2Qeki",
  "ProductIcon--negative": "ProductIcon__ProductIcon--negative___2lT3I",
  "ProductIcon--warning": "ProductIcon__ProductIcon--warning___Zbu7i",
  "ProductIcon--secondary": "ProductIcon__ProductIcon--secondary___3-T_d",
  "ProductIcon--muted": "ProductIcon__ProductIcon--muted___10ouD"
};
var iconComponents = {
  Spaces: _Spaces["default"],
  Apis: _Apis["default"],
  Apps: _Apps["default"],
  Billing: _Billing["default"],
  ContentModel: _ContentModel["default"],
  Content: _Content["default"],
  Home: _Home["default"],
  Media: _Media["default"],
  Oauth: _Oauth["default"],
  OrgInfo: _OrgInfo["default"],
  Organizations: _Organizations["default"],
  Purchase: _Purchase["default"],
  Settings: _Settings["default"],
  Sso: _Sso["default"],
  Subscription: _Subscription["default"],
  Teams: _Teams["default"],
  Token: _Token["default"],
  Usage: _Usage["default"],
  UserProfile: _UserProfile["default"],
  Users: _Users["default"]
};

var ProductIcon = function ProductIcon(_ref) {
  var _cn;

  var className = _ref.className,
      icon = _ref.icon,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'positive' : _ref$color,
      _ref$testId = _ref.testId,
      testId = _ref$testId === void 0 ? 'cf-ui-navigation-icon' : _ref$testId,
      _ref$tag = _ref.tag,
      tag = _ref$tag === void 0 ? 'div' : _ref$tag,
      otherProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var classNames = (0, _classnames["default"])(styles.ProductIconContainer, (_cn = {}, (0, _defineProperty2["default"])(_cn, styles["ProductIconContainer--".concat(size)], size), (0, _defineProperty2["default"])(_cn, styles['ProductIconContainer--trimmed'], icon.toLowerCase().includes('trimmed')), _cn), className);
  var svgFillClass = (0, _classnames["default"])(styles.ProductIcon, (0, _defineProperty2["default"])({}, styles["ProductIcon--".concat(color)], color), className);
  var Element = iconComponents[icon];
  var Tag = tag;
  return /*#__PURE__*/_react["default"].createElement(Tag, {
    className: classNames,
    "data-test-id": testId
  }, /*#__PURE__*/_react["default"].createElement(Element, (0, _extends2["default"])({
    className: svgFillClass
  }, otherProps)));
};

exports.ProductIcon = ProductIcon;
var _default = ProductIcon;
exports["default"] = _default;